import { DynamicFormInputItems, IFlow, IFlowSession } from "config";
import { gql } from "config/graphql";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

interface ICreateFlowSessionData {
  createFlowSession: {
    flowSession: {
      id: IFlowSession["id"];
    };
  };
}

export const createFlowSessionMutation = async (flowId: IFlow["id"], fromStart: boolean) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation createFlowSession($input: CreateFlowSessionInput!) {
      createFlowSession(input: $input) {
        flowSession {
          id
        }
      }
    }
  `;

  const { data } = await client.mutate<ICreateFlowSessionData>({
    variables: { input: { flowId, fromStart } },
    mutation,
  });
  return { data: assertDefined(data) };
};

interface ICreateResponse {
  field: {
    id: DynamicFormInputItems["content"]["id"];
    key: DynamicFormInputItems["key"];
  };
  flowSession: {
    id: IFlowSession["id"];
  };
  response: {
    value: unknown;
    inputType: DynamicFormInputItems["type"];
  };
}

interface ICreateFlowResponseData {
  createResponse: ICreateResponse[];
}

export const createFlowResponseMutation = async (
  flowSessionId: IFlowSession["id"],
  fieldResponses: {
    fieldId: DynamicFormInputItems["content"]["id"];
    response: { inputType: DynamicFormInputItems["type"]; value: unknown };
  }[]
) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation createResponse($input: CreateResponseInput!) {
      createResponse(input: $input) {
        flowSession {
          id
        }
        field {
          id
          key
        }
        response
      }
    }
  `;

  const { data } = await client.mutate<ICreateFlowResponseData>({
    variables: {
      input: { flowSessionId, fieldResponses },
    },
    mutation,
  });
  return { data: assertDefined(data) };
};
